import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import { COLOR_BLACK } from '../../lib/colors'

function UIRadio({
  disabled,
  checked = false,
  onChange,
  label,
  name,
  value,
  dynamicStyle,
  ...props
}) {
  return (
    <div className={css(styles.container, dynamicStyle)}>
      <input
        type="radio"
        name={name}
        className={css(styles.default)}
        disabled={disabled}
        value={value}
        checked={checked}
        {...props}
        onChange={onChange}
      />
      <label className={css(styles.label)}>{label} </label>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  default: {
    margin: 5,
    width: 20,
    height: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: COLOR_BLACK,
  },
})

UIRadio.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  dynamicStyle: PropTypes.node,
}

export default UIRadio
